/* eslint-disable @typescript-eslint/naming-convention */
import type { AxiosResponse } from 'axios'
import axios from 'axios'

export type SetPositionCategoryIdType = string | number | null

export interface SetPositionCategoryType {
  category_id: SetPositionCategoryIdType
  category_image: string | null
  category_name: string
  count_product: number
}

export interface SetPositionProductType {
  product_id: string | number
  product_image: string | null
  product_name: string
  product_sku_number: string
  position: string | number
}

export interface SetPositionPageType<ItemType> {
  content: ItemType[]
  numberOfElements: number
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface SetPositionPayloadType {
  category_id: SetPositionCategoryIdType
  product_id: string | number
  position: string | number | undefined
}

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getPPCatParent_SL = (query = ''): Promise<AxiosResponse<SetPositionCategoryType[]>> =>
  axios.get(`${baseUrl}/api/product-position/categories/parent${query}`)

export const getPPCatChild_SL = (
  category_id: SetPositionCategoryIdType,
  query = '',
): Promise<AxiosResponse<SetPositionPageType<SetPositionCategoryType>>> =>
  axios.get(`${baseUrl}/api/product-position/categories/child/${category_id}${query}`)

export const getProductPosition = (
  category_id: SetPositionCategoryIdType,
  query = '',
): Promise<AxiosResponse<SetPositionPageType<SetPositionProductType>>> =>
  axios.get(`${baseUrl}/api/product-position/${category_id}${query}`)

export const postAddProductPosition = (
  data: SetPositionPayloadType,
): Promise<AxiosResponse<unknown>> => axios.post(`${baseUrl}/api/product-position`, data)
